<template>
  <div class="flex h-full w-full p-2">
    <div class="flex w-full gap-1">
      <NBox class="basis-1/3 2xl:basis-[30%] p-2 mb-2 h-fit">
        <div class="border-b border-neutral-secondary">
          <div
            v-for="item in 2"
            :key="item"
            class="flex justify-between mb-1.5"
          >
            <TextSkeleton height="11px" :width="`${item * 40}px`" />
            <TextSkeleton height="11px" :width="`${item * 30}px`" />
          </div>
        </div>

        <div class="space-y-1.5">
          <div v-for="item in 8" :key="item" class="flex justify-between p-1.5">
            <TextSkeleton height="11px" :width="`${((item % 3) + 1) * 20}px`" />
            <TextSkeleton height="11px" :width="`${((item % 3) + 1) * 10}px`" />
          </div>
        </div>
      </NBox>

      <div class="w-full basis-2/3 2xl:basis-[70%]">
        <NBox class="flex justify-between gap-1 p-2 mb-2" border>
          <TextSkeleton height="11px" width="100%" class="w-full" />
          <TextSkeleton height="11px" width="100%" class="w-full" />
        </NBox>

        <NBox class="mb-2 p-3" border>
          <div
            v-for="item in 8"
            :key="item"
            class="flex justify-center mb-2 gap-3 last:mb-0"
          >
            <TextSkeleton height="11px" :width="`${((item % 4) + 1) * 40}px`" />
            <TextSkeleton height="11px" :width="`${((item % 4) + 1) * 40}px`" />
          </div>
        </NBox>

        <NBox class="p-3" border>
          <div
            v-for="item in 2"
            :key="item"
            class="flex justify-center mb-2 last:mb-0 text-left gap-1"
          >
            <TextSkeleton height="11px" :width="`${item * 40}px`" />
            <TextSkeleton height="11px" :width="`${item * 40}px`" />
          </div>
        </NBox>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TextSkeleton from '@/components/TextSkeleton.vue';
</script>
